var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoodleGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 31,
    viewBox: "0 0 447 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0659 3.62305H0.855469V26.7031H24.0659V3.62305ZM20.4283 7.27522H4.52001V23.0531H20.4283V7.27522Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9196 4.57291C89.1772 4.90691 88.4761 5.31646 87.8261 5.79177L104.095 22.0609C104.571 21.4109 104.98 20.7098 105.314 19.9674L89.9196 4.57291ZM106.329 14.8777C106.164 8.70051 101.186 3.72333 95.0093 3.55762L106.329 14.8777ZM83.808 11.0514C84.0911 10.3084 84.4481 9.60183 84.8701 8.94071L100.946 25.0169C100.285 25.4389 99.5786 25.7959 98.8356 26.079L83.808 11.0514ZM93.4214 26.7698L83.1172 16.4656C83.7046 21.8812 88.0058 26.1824 93.4214 26.7698Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.396 20.1435C174.458 20.1435 181.805 12.797 181.805 3.73455C181.805 3.73254 181.805 3.73053 181.805 3.72852H188.248C188.248 6.73174 187.657 9.70555 186.507 12.4802C185.358 15.2548 183.673 17.7759 181.55 19.8995C179.426 22.0231 176.905 23.7076 174.131 24.8569C171.356 26.0062 168.382 26.5977 165.379 26.5977L165.379 20.1435C165.385 20.1435 165.39 20.1435 165.396 20.1435Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.297 4.40913L247.297 7.67094L265.418 7.67094L265.418 25.917L268.68 25.917L268.68 4.53397L268.68 4.53397L268.68 4.40913L247.297 4.40913Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.892 19.6672C358.209 18.8287 358.435 17.9638 358.57 17.0875L333.151 17.0874C333.286 17.9637 333.513 18.8287 333.83 19.6672L357.892 19.6672ZM337.002 24.4361C341.961 29.1522 349.76 29.1522 354.719 24.4361L337.002 24.4361ZM357.596 9.84012C357.956 10.6417 358.229 11.4725 358.417 12.3186L333.304 12.3186C333.492 11.4725 333.765 10.6416 334.125 9.8401L357.596 9.84012ZM337.821 5.07123L353.9 5.07124C349.215 1.3097 342.506 1.3097 337.821 5.07123Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.253 3.62305H423.043V26.7031H446.253V3.62305ZM442.615 7.27519H426.707V23.0531H442.615V7.27519Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodleGroup);
export default __webpack_public_path__ + "static/media/doodleGroup.034026e42195860f4911de4ddbb7387e.svg";
export { ForwardRef as ReactComponent };